import React, { useEffect, useState } from 'react';
import { PhoneButton } from './PhoneButton';
const links = [{
  href: '#specials',
  label: 'Especiales'
}, {
  href: '#menu',
  label: 'Menú'
}, {
  href: '#hours',
  label: 'Horario'
}];
export function SiteHeader() {
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <header className={`sticky top-0 z-50 w-full border-b bg-night/95 backdrop-blur transition-[box-shadow,border-color] duration-200 ease-out ${scrolled ? 'border-gold/20 shadow-[0_8px_24px_-12px_rgba(0,0,0,0.9)]' : 'border-transparent'}`} data-id="element-84" data-mp="qygnltgnwldr">
      <div className="h-0.5 w-full bg-gold-gradient" aria-hidden="true" data-id="element-85" data-mp="2gaisfv2d3ntk" />
      <div className="wrap flex h-[calc(var(--header-h)-2px)] items-center justify-between gap-3" data-id="element-86" data-mp="2bcqzqytw7xob">
        <a href="#top" className="fs-logo text-gold-gradient whitespace-nowrap font-display font-bold leading-none" data-id="element-87" data-mp="29k2a4fp4jlug">
          Oh My Tacos
        </a>
        <nav aria-label="Main" className="flex items-center gap-[clamp(0.75rem,2.2vw,5rem)]" data-id="element-88" data-mp="2ehc13zs5w5ke">
          {links.map(l => <a key={l.href} href={l.href} className="fs-nav hidden font-label uppercase tracking-[0.18em] text-muted transition-colors duration-150 ease-out hover:text-gold focus:outline-none focus-visible:text-gold-light sm:inline" data-id="element-89" data-mp="2jg5fduf9w0lm">
              {l.label}
            </a>)}
          <PhoneButton label="Call to order" size="sm" data-id="element-90" data-mp="20r8l3qjvl83e" />
        </nav>
      </div>
    </header>;
}